import { useMutation } from "react-query";
import { Post } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
export default () => {
  const { getAccessTokenSilently } = useAuth0();
  return useMutation<{}, null, string>(
    async (inviteId: string) =>
      Post(
        `/api/invite/resend/${inviteId}`,
        await getAccessTokenSilently(),
        {}
      ),
    {}
  );
};
